import { Option } from "../engine/models/models";
import { InspirationRoomOptionModel } from "./InspirationRoomOptionModel";
import { InspirationRoomTipsModel } from "./InspirationRoomTipsModel";

export class InspirationRoomModel {
  areaId: number;
  backgroundUrl: string;
  origin: string;
  cropperPosition: string;
  id: number;
  displayOrder: number;
  isActive: boolean;
  isStaged: boolean;
  name: string;
  options: InspirationRoomOptionModel[];
  tips: InspirationRoomTipsModel[];
  requiredOptions: Option[];
  thumbnailUrl: string;
  backgroundId: number;
  thumbnailId: number;
  createdbyId: string;
  globalOptions: Option[];
  communityId: number;
  lot: string;
  dsAreaId: number;
  selectedCode: string;
  inspirationGroupId: number;
  inspirationSubGroupId: number;
  hasInactiveOptions: boolean;
  optionCountSet: boolean;
  inactiveOptionCount: number;
  totalTagsCount: number;
}
